import { styled, Avatar } from "@mui/material";

export const ReviewAvatar = styled(Avatar)`
  height: 24px;
  width: 24px;
  margin-right: 5px;
  object-fit: fill;
`;
